import { render, staticRenderFns } from "./KasBesarList.vue?vue&type=template&id=66db7eec"
import script from "./KasBesarList.vue?vue&type=script&lang=js"
export * from "./KasBesarList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports